import cliffOptions from 'constants/cliffOptions';

export const getCliffMonths = (months: Number) =>
  cliffOptions.find((option) => option.value === Number(months))?.text;
